import React from 'react';
import { Space, Badge, theme } from 'antd';

type FilterColor = 'blue' | 'green' | 'orange';

export interface StatusFilterItem<T = any> {
  key: T;
  color: FilterColor;
  label: string;
  count?: number | string;
}

interface StatusFilterBarProps<T = any> {
  items: StatusFilterItem<T>[];
  value: T | null;
  onChange: (value: T | null) => void;
}

const COLOR_MAP: Record<FilterColor, { tokenBorder: string; tokenBg: string }> = {} as any;

const StatusFilterBar = <T = any,>({
  items,
  value,
  onChange,
}: StatusFilterBarProps<T>) => {
  const { token } = theme.useToken();

  const colorConfig: Record<FilterColor, { border: string; bg: string }> = {
    blue:   { border: token.colorPrimary, bg: token.colorPrimaryBg },
    green:  { border: token.colorSuccess, bg: token.colorSuccessBg },
    orange: { border: token.colorWarning, bg: token.colorWarningBg },
  };

  return (
    <Space>
      {items.map(({ key, color, label, count }) => {
        const active = value === key;
        const cfg = colorConfig[color];
        return (
          <div
            key={String(key)}
            onClick={() => onChange(active ? null : key)}
            style={{
              display: 'flex',
              alignItems: 'center',
              border: `1px solid ${active ? cfg.border : token.colorBorderSecondary}`,
              borderRadius: 6,
              padding: '8px 12px',
              fontSize: 14,
              cursor: 'pointer',
              background: active ? cfg.bg : undefined,
              color: active ? cfg.border : token.colorText,
              transition: 'all 0.2s',
              userSelect: 'none',
            }}
          >
            <Badge color={active ? cfg.border : color} style={{ marginRight: 4 }} />
            {label}
            {count !== undefined && count !== '' && <span style={{ marginLeft: 4 }}>{count}</span>}
          </div>
        );
      })}
    </Space>
  );
};

export default StatusFilterBar;
